import React, { useContext, useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { ModalContext } from 'context/ModalContext';
import { show_toast } from 'utils/helpers';
import { X } from 'react-feather';
import { register_valuer, upload_api } from 'services/apiSrv';
import { useQueryClient } from 'react-query';

export default function Add_Valuer({ onAdd }) {
  const { modalClose } = useContext(ModalContext);
  const [imagePreview, setImagePreview] = useState('');
  const [areas, setAreas] = useState([]);
  const [areaInput, setAreaInput] = useState('');
const queryClient= useQueryClient()
  useEffect(() => {
    return () => {
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  const addArea = () => {
    const trimmed = (areaInput || '').trim();
    if (!trimmed) return;
    if (areas.includes(trimmed)) {
      show_toast('Area already added', 'warning');
      return;
    }
    setAreas((prev) => [...prev, trimmed]);
    setAreaInput('');
  };

  const removeArea = (a) => setAreas((prev) => prev.filter((x) => x !== a));

  const handleImageChange = async (e, setFieldValue) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    try {
      const res = await upload_api("ValuerLogo", file);
      console.log("===imageResponse", res.data[0]);
      setImagePreview(res.data[0].fileUrl)
  
      
      setFieldValue('profileImage', res?.data[0]?.fileUrl || res);
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };
  

  // --- style tokens copied from valuation config improvements ---
  const inputStyle = {
    padding: '0.7rem 0.9rem',
    border: '1px solid #e6e8eb',
    borderRadius: '0.5rem',
    backgroundColor: '#fff',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)'
  };
  const selectStyle = {
    ...inputStyle,
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    paddingRight: '2.2rem',
    minHeight: '44px'
  };
  const sectionTitleStyle = { fontWeight: 700, color: '#374151', marginBottom: 8, fontSize: 14 };
  const smallMuted = { color: '#6b7280', fontSize: 13 };
  const formGroupStyle = { marginBottom: 14 };
  // --- end style tokens ---

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Valuer name is required'),
    email: Yup.string().email('Invalid email').nullable(),
    phone: Yup.string().nullable(),
    internalRef: Yup.string().nullable(),
    addresses: Yup.string().nullable(),
    valuerRef:Yup.string()
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const contacts = [`${values.email , ''}${values.phone ? ` , ${values.phone}` : ''}`.trim()];

      const newValuer = {
      
        imagePath: imagePreview || '',
        names: values.name,
        contacts,
        contactPerson:{
        names:values.name,
        email: values.email || '',
        phone: values.phone || '',
        },
       
        internalRef: values.internalRef || `INT-VAL-${Math.floor(Math.random() * 9000) + 1000}`,
        areasCovered: areas,
        valuerInternalRef:values.valuerRef
      };

      if (typeof onAdd === 'function') {
        onAdd(newValuer);
      }
      const res= await register_valuer({valuer:newValuer})
      console.log("==valuer res==", res)
      queryClient.invalidateQueries("valuer_panel")
      show_toast('Valuer added', 'success');
      resetForm();
      setAreas([]);
      setImagePreview('');
      modalClose();
    } catch (err) {
      console.error('Failed to add valuer', err);
      show_toast('Failed to add valuer', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded" style={{ boxShadow: '0 6px 20px rgba(11,23,39,0.04)' }}>
      <Formik
        initialValues={{ name: '', email: '', phone: '', internalRef: '', addresses: '', profileImage: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>

              {/* Image upload & preview */}
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div>
                  <label style={sectionTitleStyle}>Profile Image</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 96, height: 96, borderRadius: 12, overflow: 'hidden', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(15,23,42,0.04)' }}>
                      {imagePreview ? (
                        <img src={imagePreview} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <div style={{ color: '#9ca3af' }}>No image</div>
                      )}
                    </div>
                    <div>
                      <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, setFieldValue)} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Arrange Name, Email, Phone, Internal Reference in a two-column grid (option two) */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, alignItems: 'start' }}>
                {/* Valuer Name */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Valuer Name <span className="text-danger">*</span></label>
                  <input
                    name="name"
                    type="text"
                    className="form-control"
                    value={values.name}
                    onChange={handleChange}
                    placeholder="Enter valuer full name"
                    style={inputStyle}
                  />
                  <ErrorMessage name="name" component="div" className="invalid-feedback d-block" />
                </div>

                {/* Email */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Email</label>
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    value={values.email}
                    onChange={handleChange}
                    placeholder="Valuer email"
                    style={inputStyle}
                  />
                  <ErrorMessage name="email" component="div" className="invalid-feedback d-block" />
                </div>

                {/* Phone */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Phone</label>
                  <input
                    name="phone"
                    type="text"
                    className="form-control"
                    value={values.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                    style={inputStyle}
                  />
                  <ErrorMessage name="phone" component="div" className="invalid-feedback d-block" />
                </div>

                {/* Internal Reference */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Internal Reference</label>
                  <input
                    name="internalRef"
                    type="text"
                    className="form-control"
                    value={values.internalRef}
                    onChange={handleChange}
                    placeholder="Optional internal reference"
                    style={inputStyle}
                  />
                  <ErrorMessage name="internalRef" component="div" className="invalid-feedback d-block" />
                </div>
              </div>

              {/* Areas covered with add button and listing */}
              <div style={formGroupStyle}>
                <label style={sectionTitleStyle}>Areas Covered</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    type="text"
                    className="form-control"
                    value={areaInput}
                    onChange={(e) => setAreaInput(e.target.value)}
                    placeholder="e.g. Nairobi, Mombasa"
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addArea(); } }}
                    style={inputStyle}
                  />
                  <button type="button" className="btn btn-outline-primary" onClick={addArea}>Add</button>
                </div>

                <div className="mt-2">
                  {areas.length === 0 ? (
                    <div className="text-muted">No areas added yet</div>
                  ) : (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                      {areas.map((a) => (
                        <div key={a} className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 border" style={{ fontSize: '0.9rem' }}>
                          {a}
                          <X size={14} style={{ cursor: 'pointer' }} onClick={() => removeArea(a)} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Addresses */}
              <div style={formGroupStyle}>
                <label style={sectionTitleStyle}>Addresses</label>
                <textarea
                  name="addresses"
                  className="form-control"
                  rows="3"
                  value={values.addresses}
                  onChange={handleChange}
                  placeholder="Enter address(es)"
                  style={{ ...inputStyle, minHeight: 84 }}
                />
                <ErrorMessage name="addresses" component="div" className="invalid-feedback d-block" />
              </div>
              <div style={formGroupStyle}>
                <label style={sectionTitleStyle}>Valuer Ref</label>
                <textarea
                  name="valuerRef"
                  className="form-control"
                  rows="3"
                  value={values.valuerRef}
                  onChange={handleChange}
                  placeholder="Enter valuer ref(es)"
                  style={{ ...inputStyle, minHeight: 84 }}
                />
                <ErrorMessage name="valuerRef" component="div" className="invalid-feedback d-block" />
              </div>


              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
                <button type="button" className="btn btn-secondary" onClick={modalClose} disabled={isSubmitting}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Saving...' : 'Save Valuer'}
                </button>
              </div>

            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
